import styled from "@emotion/styled";
import { getLanguage, getNavPath } from "auth-provider";
import { ThemeText } from "components/lib";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LabelType, PageHeader } from "screens/register/page-header";
import { RestaurantConfig } from "screens/register/contant";
import backIcon from "assets/backIcon.png";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import { AgreementContent } from "./agreement";
import { useUrlQueryParam } from "utils/url";

export const RestaurantNotify = (props: any) => {
  const navigate = useNavigate();
  const [lang, setLang] = useState(getLanguage() as LabelType);
  const [headerVisible, setHeaderVisible] = useState(true);

  const [{ orderSource }] = useUrlQueryParam(["orderSource"]);
  useEffect(() => {
    setHeaderVisible(orderSource !== "kiosk");
  }, [orderSource]);

  const trackCommonData = useTrackCommonData();

  const jumpToRestaurant = (type: "member") => {
    const navPath = getNavPath(type);
    navigate(navPath, { replace: true });
  };

  const changeLang = (val: LabelType) => {
    setLang(val);
    props?.setLang?.(val);
  };

  trackMixPanel(
    MIX_PANEL_EVENT.HOME_PAGE_AGREEMENT_SHOW_SUCCESS,
    trackCommonData
  );

  const handleClick = () => {
    trackMixPanel(MIX_PANEL_EVENT.HOME_PAGE_AGREEMENT_BACK, trackCommonData);
    jumpToRestaurant("member");
  };
  return (
    <>
      {headerVisible && (
        <PageHeader changeLang={changeLang}>
          <LinkArrow onClick={handleClick}>
            <img
              src={backIcon}
              alt={"back png"}
              style={{
                width: "0.6rem",
                height: "1.4rem",
                marginRight: "1.3rem",
              }}
            />
            <ThemeText fontWieght={500}>
              {RestaurantConfig.title?.[lang]}
            </ThemeText>
          </LinkArrow>
        </PageHeader>
      )}

      <NotifyWrapper isKiosk={!headerVisible}>
        <TitleItem isKiosk={!headerVisible}>{AgreementContent.title}</TitleItem>
        <div>
          {AgreementContent.content.map((item, index) => {
            return (
              <div key={"c_" + index}>
                {/* 标题 */}
                <HeaderItem iIndex={index} isKiosk={!headerVisible}>
                  {item.h}
                </HeaderItem>
                {(
                  item.p.map((pItem, pIndex) => {
                    return pItem.includes("<a>") ? (
                      <AgreeItem
                        key={"p_" + pIndex}
                        isKiosk={!headerVisible}
                        className={"notifyContent"}
                        dangerouslySetInnerHTML={{ __html: pItem }}
                      ></AgreeItem>
                    ) : (
                      <AgreeItem key={"p_" + pIndex} isKiosk={!headerVisible}>
                        {pItem}
                      </AgreeItem>
                    );
                  })
                )}
              </div>
            );
          })}
        </div>
      </NotifyWrapper>
    </>
  );
};

export const LinkArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const NotifyWrapper = styled.div<{
  isKiosk?: boolean;
}>`
  padding: 1.6rem;
  color: ${(props) => (props.isKiosk ? "#ccc !important" : "#EDD6B4")};
`;

export const TitleItem = styled.div<{
  isKiosk?: boolean;
}>`
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.8rem;
  height: 1.8rem;
  margin-bottom: 2.4rem;
  color: ${(props) => (props.isKiosk ? "#1D1B2E" : "#EDD6B4")};
`;

export const HeaderItem = styled.div<{
  iIndex?: number;
  isKiosk?: boolean;
}>`
  margin-top: ${(props) => (props.iIndex && props.iIndex > 0 ? "1.2rem" : 0)};
  font-size: 1.6rem;
  font-weight: 500;
  color: ${(props) => (props.isKiosk ? "#1D1B2E" : "#EDD6B4")};
`;
export const AgreeItem = styled.li<{
  isKiosk?: boolean;
}>`
  font-size: 1.4rem;
  color: ${(props) => (props.isKiosk ? "#1D1B2E" : "#edd6b4")};
`;
